import CONST from '../../consts';
import { IGlobalState } from '../../states/GlobalState';
import { UbiverseSequenceNote } from '../../types';
import './index.scss'
import { useEffect } from 'react';

interface TimelineNoteProps {
  id: string;
  intensity: number;
  position: number;
  cellSize: { width: number, height: number };
  state: IGlobalState;
  sequence: UbiverseSequenceNote[];
  small?: boolean;
  isEraserHover?: boolean;
  onMouseDown: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseEnter?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseMove?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const TimelineNoteDelayIndicator = ({ width, height }: { width: number, height: number }) => {
  const aspectRatio = width / height
  const viewBoxWidth = height * aspectRatio
  const viewBoxHeight = height

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} 
      fill="none"
    >
      <path 
        d={`M0.185182 ${viewBoxHeight - 0.004}C${viewBoxWidth/3} ${viewBoxHeight - 0.54} ${viewBoxWidth - 0.37} ${viewBoxHeight * 0.8} ${viewBoxWidth} 0V${viewBoxHeight}H0.185182C0.12291 ${viewBoxHeight + 0.005} 0.061178 ${viewBoxHeight + 0.005} 0 ${viewBoxHeight}H0.185182Z`}
        fill="#CF2C00" // Changed to orange
      />
    </svg>
  )
}

const TimelineNote = ({ intensity, position, cellSize, isEraserHover, onMouseDown, onMouseEnter, onMouseMove, onMouseLeave, state, sequence, id, small }: TimelineNoteProps) => {
  const delaySamples = CONST.sampleDelay.reference[intensity - 1]
  const delaySeconds = delaySamples * CONST.sampleDelay.secondsPerSample

  const quarterNoteDuration = 60 / state.control.bpm
  const delayIndicatorWidth = (delaySeconds / quarterNoteDuration) * cellSize.width

  const previousSequenceIndex = sequence.sort((a, b) => a.position - b.position).findIndex((s) => id === s.id)
  const previousSequence = sequence[previousSequenceIndex - 1] || null
  const isIllegal = previousSequence && ((position * cellSize.width - delayIndicatorWidth) < previousSequence.position * cellSize.width)

  useEffect(() => {
    console.log('isEraserHover', isEraserHover)
  }, [isEraserHover])

  return (
    <div
      className={`component--timeline-note ${isIllegal ? 'component--timeline-note--illegal' : ''} ${small ? 'component--timeline-note__small' : ''} ${isEraserHover ? 'component--timeline-note--erase-hover' : ''}`}
      style={{
        left: `${position * cellSize.width}px`,
        height: `${intensity * cellSize.height}px`
      }}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
    >
      <div className="component--timeline-note__note__delay-indicator">
        <TimelineNoteDelayIndicator width={delayIndicatorWidth} height={intensity * cellSize.height} />
      </div>
    </div>
  )
}

export default TimelineNote
